import { BrowserModule } from '@angular/platform-browser';
import { NgModule, APP_INITIALIZER, LOCALE_ID } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { OverlayModule } from '@angular/cdk/overlay';

import { NgbModule, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { L10nTranslationModule, L10nIntlModule, L10nValidationModule, L10nRoutingModule, L10nLoader } from 'angular-l10n';
import { DeviceDetectorModule } from 'ngx-device-detector';

import { l10nConfig, initL10n, AppStorage, HttpTranslationLoader, LocaleValidation } from './l10n-config';
import { NgbDateMomentParserFormatter } from './ngb-date-moment-parser-formatter';

import { WINDOW_PROVIDERS } from './_services/window.service';
import { SlideInPanelService } from './_services/slide-in-panel.service';
import { AppInitService } from './_services/app-init.service';
import { LoggerService } from './_services/logger.service';
import { ConfigService } from './_services/config.service';
import { UtilityService } from './_services/utility.service';
import { AlertService } from './_services/alert.service';
import { SessionService } from './_services/session.service';
import { MapService } from './_services/map.service';
import { ParentMessageService } from './_services/parent-message.service';

import { ErrorInterceptor } from './_interceptors/error.interceptor';
import { SpinnerInterceptor } from './_interceptors/spinner.interceptor';

import { initApp } from './app-init';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { SidePanelModule } from './_modules/side-panel/side-panel.module';
import { LayoutComponent } from './layout/layout.component';
import { MapComponent } from './map/map.component';
import { NotFoundComponent } from './not-found/not-found.component';
import { SlideInPanelComponent } from './shared/slide-in-panel/slide-in-panel.component';
import { SpinnerComponent } from './shared/spinner/spinner.component';
import { SpinnerOverlayComponent } from './shared/spinner-overlay/spinner-overlay.component';
import { ToastsComponent } from './shared/toasts/toasts.component';

import '@angular/common/locales/global/it';
import '@angular/common/locales/global/en';

@NgModule({
  declarations: [
    AppComponent,
    LayoutComponent,
    MapComponent,
    NotFoundComponent,
    SlideInPanelComponent,
    SpinnerComponent,
    SpinnerOverlayComponent,
    ToastsComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    ReactiveFormsModule,
    FormsModule,
    HttpClientModule,
    NgbModule,
    SidePanelModule,
    BrowserAnimationsModule,
    OverlayModule,
    L10nTranslationModule.forRoot(
      l10nConfig,
      {
        storage: AppStorage,
        translationLoader: HttpTranslationLoader
      }
    ),
    L10nIntlModule,
    L10nValidationModule.forRoot({ validation: LocaleValidation }),
    L10nRoutingModule.forRoot(),
    DeviceDetectorModule
  ],
  providers: [
    SlideInPanelService,
    {
      provide: LOCALE_ID,
      deps: [SessionService],
      useFactory: (SessionService: { locale: string; }) => SessionService.locale
    },
    WINDOW_PROVIDERS,
    {
      provide: APP_INITIALIZER,
      useFactory: initL10n,
      deps: [L10nLoader],
      multi: true
    },
    {
      provide: APP_INITIALIZER,
      useFactory: initApp,
      deps: [AppInitService],
      multi: true
    },
    SessionService,
    UtilityService,
    AlertService,
    ConfigService,
    AppInitService,
    LoggerService,
    MapService,
    ParentMessageService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: SpinnerInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorInterceptor,
      multi: true
    },
    {
      provide: NgbDateParserFormatter,
      useClass: NgbDateMomentParserFormatter
    },
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
